<template>
  <figure class="blog-illustration">
    <img
      :src="src"
      :srcset="srcset || undefined"
      sizes="(min-width: 1100px) 888px, (min-width: 720px) 688px, calc(100vw - 32px)"
      :alt="alt"
      :width="width"
      :height="height"
      loading="lazy"
      decoding="async"
    />
    <figcaption v-if="caption">{{ caption }}</figcaption>
  </figure>
</template>

<script setup lang="ts">
/* A distinct content block keeps section artwork in place: the editorial
   layout may hoist ordinary Markdown screenshots into the lead position. */
defineProps<{
  src: string;
  srcset?: string;
  alt: string;
  width: number;
  height: number;
  caption?: string;
}>();
</script>

<style scoped>
.blog-illustration {
  margin: 2.25rem 0;
}

.blog-illustration img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
